<div class="container" style="overflow:auto">
  <div class="container-fluid p-0">
    <img class="card-img-top" id="BannerImage" src='assets/Images/Publishers/{{modelItem.TopBannerImage}}' alt="TopBannerImage" />
  </div>
  <div class="divFeedbackTitle">{{modelItem.FeedbackTitle}}</div>
  <div class="bodycontent">
    <div class="divFeedbackTopContent" innerHTML="{{modelItem.FeedbackTopContent}}"></div>
    <div class="container">

      <div class="row tblfeedbacklist col-md-12">
        <table class="tablecontent" id="tblfeedbacklist">
          <thead>
            <tr>
              <th>Feedback Name</th>
              <th>Feedback Ratings</th>
            </tr>
          </thead>
          <tbody class="tblfeedbacklistbody">
            <tr *ngFor="let item of modelItem.FeedbackNamelist; let i = index;">
              <td>{{item.FeedbackName}} </td>
              <td>
                <div class="emoji-div">
                  <div class="rating" id={{i+1}}>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="divFeedbackTopContent" innerHTML="{{modelItem.FeednackBottomContent}}"></div>
      <div>
        <textarea type="text" class="form-control" id="txtFeedbackDesc"> {{modelItem.FeedbackDesc}}</textarea>
      </div>
      <div class="divbtn">
        <button type="button" class="btn btn-outline-danger waves-effect " data-dismiss="modal" id="btnsave" (click)="savefeedbackinfo()">SUBMIT</button>
      </div>
    </div>

  </div>
</div>
